import { useMemo, useState } from 'react';

import {
  ImageDisplayQuality,
  getClosestImageUrl,
} from 'approot/shared/images/imgix-responsive';
import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';
import { ComponentImageContainer } from './component-image.style';

export const ComponentImage = ({
  images,
  altText,
  imageDimensions,
}: {
  images: ResponsiveImage[];
  altText?: string | null;
  imageDimensions?: { width: number; height: number };
}) => {
  const [ref, setRef] = useState<HTMLPictureElement | null>();
  const imageUrl = useMemo(() => {
    if (!imageDimensions?.width && !ref?.offsetWidth) return '';
    return getClosestImageUrl({
      imageUrls: images,
      containerSize: imageDimensions?.width
        ? Math.max(imageDimensions.width, imageDimensions.height)
        : ref
        ? Math.max(ref.offsetWidth, ref.offsetHeight)
        : 0,
      quality: ImageDisplayQuality.High,
    });
  }, [images, imageDimensions, ref]);

  return (
    <ComponentImageContainer
      $imageHasLoaded={!!imageUrl}
      ref={el => {
        setRef(el);
      }}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={altText || ''}
          style={
            imageDimensions
              ? {
                  width: imageDimensions.width,
                  height: imageDimensions.height,
                }
              : undefined
          }
        />
      )}
    </ComponentImageContainer>
  );
};
